import axios from 'axios';
export default class NotificationService {

    fetchNotifications(userRefId, pageNumber) {
        let accessToken= sessionStorage.getItem('access_token');
        console.log("ACCESS TOKEN: "+accessToken);
        
        return axios.get(`${process.env.VUE_APP_API_ROOT}/notifications/${userRefId}/5/${pageNumber}`,
            {
                headers:{
                    'Authorization': 'Bearer '+accessToken
                }
            }
        )
        .then(res => res.data);
        
    }

    acknowledgeEvent(eventId, userRefId) {
        let accessToken= sessionStorage.getItem('access_token');
        let payload={
            eventId:eventId,
            userRefId:userRefId
        };
        return axios.post(`${process.env.VUE_APP_API_ROOT}/notification/ack`,payload,
            {
                headers:{
                    'Authorization': 'Bearer '+accessToken
                }
            }
        );
    }
}